import { render } from "./FilePondDemo.vue?vue&type=template&id=179eef16"
import script from "./FilePondDemo.vue?vue&type=script&lang=js"
export * from "./FilePondDemo.vue?vue&type=script&lang=js"

import "./FilePondDemo.vue?vue&type=style&index=0&id=179eef16&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__